// extracted by mini-css-extract-plugin
export default {"resetButton":"resetButton---l0F2H"};